import { proxy } from "valtio"

import { streamClient } from "@helpers/streamClient"

export interface StreamUnreadState {
	// Number of unread messages
	unreadMessagesCount: number
	// Number of channels with unread messages
	unreadChannelsCount: number
	initialized: boolean
	initializing: boolean
}

/**
 * https://getstream.io/chat/docs/react/unread/
 */
class StreamUnreadStore {
	public state = proxy<StreamUnreadState>({
		unreadMessagesCount: 0,
		unreadChannelsCount: 0,
		initialized: false,
		initializing: false,
	})

	private unsubscriber: null | {
		unsubscribe: () => void
	} = null

	/**
	 * Call when authentication is complete with the initial values from `connectUser`.
	 */
	init = (unreadMessagesCount: number, unreadChannelsCount: number) => {
		this.state.unreadMessagesCount = unreadMessagesCount
		this.state.unreadChannelsCount = unreadChannelsCount

		// Begin listening for updates from Stream
		this.unsubscriber?.unsubscribe()
		this.unsubscriber = streamClient.on((e) => {
			if (e.total_unread_count !== undefined) {
				this.state.unreadMessagesCount = e.total_unread_count
			}

			if (e.unread_channels !== undefined) {
				this.state.unreadChannelsCount = e.unread_channels
			}
		})

		this.state.initialized = true
	}
}

export const streamUnreadStore = new StreamUnreadStore()